import React, { useState } from 'react';
import l4 from '../../assets/images/edit-2.svg';

const DynamicBlock = ({
  initialLabel = "How do you feel / What brings you here today?",
  initialContent = ". Feeling pain in my lower back for several days now,\n. Especially when I sit for long periods of time.",
  inputType = "textarea",
  inputProps = {},
  editIcon = null,
  customStyles = {},
  onContentChange = () => {},
  onLabelChange = () => {},
  isVisible = true
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [labelText, setLabelText] = useState(initialLabel);
  const [content, setContent] = useState(initialContent);
  

  const handleEditClick = (e) => {
    e.preventDefault();
    setIsEditing(true);
  };

  const handleLabelChange = (e) => {
    const newValue = e.target.value;
    setLabelText(newValue);
    onLabelChange(newValue);
  };

  const handleContentChange = (e) => {
    const newValue = e.target.value;
    setContent(newValue);
    onContentChange(newValue);
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  const defaultStyles = {
    container: {
      border: '1px solid #0056B3',
      borderRadius: '10px',
      marginBottom: '1rem',
      padding: '0.5rem',
      position: 'relative',
      ...customStyles.container
    },
    label: {
      fontWeight: '600',
      ...customStyles.label
    },
    input: {
      border: "none",
      backgroundColor: "transparent",
      outline: "none",
      width: '100%',
      ...customStyles.input
    },
    textarea: {
      border: "none",
      minHeight: "2vh",
      padding: "10px",
      borderRadius: "5px",
      resize: "none",
      width: "100%",
      backgroundColor: "transparent",
      outline: "none",
      ...customStyles.textarea
    },
    editIcon: {
      marginLeft: "10px",
      ...customStyles.editIcon
    },
    editIconImage: {
      width: "1.3rem",
      marginBottom: "2.5rem",
      ...customStyles.editIconImage
    }
  };

  const renderInput = () => {
    if (inputType === 'textarea') {
      return (
        <textarea
          className="form-control"
          style={defaultStyles.textarea}
          value={content}
          onChange={handleContentChange}
          {...inputProps}
        />
      );
    } else {
      return (
        <input
          type={inputType}
          className="form-control"
          style={defaultStyles.input}
          value={content}
          onChange={handleContentChange}
          {...inputProps}
        />
      );
    }
  };

  return (
    <div className="position-relative" style={defaultStyles.container}>
      <div className="d-flex pos">
        {isEditing ? (
          <input
            type="text"
            value={labelText}
            onChange={handleLabelChange}
            onBlur={handleBlur}
            autoFocus
            style={defaultStyles.input}
          />
        ) : (
          <label style={defaultStyles.label}>
            {labelText}
          </label>
        )}

        <a
          href="#"
          onClick={handleEditClick}
          style={defaultStyles.editIcon}
        >
          {editIcon ? (
            <img
              src={editIcon}
              alt="edit"
              className="img-fluid edit"
              style={defaultStyles.editIconImage}
            />
          ) : (
            <img
              src={l4}
              alt="edit"
              className="img-fluid edit"
              style={{ width: "1.3rem", marginBottom: "2.5rem" }}
            />
          )}
        </a>
      </div>

      <div className="mt-3 d-flex justify-content-center">
        {renderInput()}
      </div>
    </div>
  );
};

export default DynamicBlock;
